// extracted by mini-css-extract-plugin
export default {"logout-container":"_logout_logout-container__SrJcD","description":"_logout_description__q+TH-"};